import { useState,useEffect } from 'react';

export const useNavigation = () => {
  const [currentPage, setCurrentPage] = useState('dashboard');
  // Set initial sidebar state based on screen size
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    return window.innerWidth >= 768; // Open on desktop, closed on mobile
  });
  const [expandedMenus, setExpandedMenus] = useState({});

  // Handle resize to adjust sidebar for screen changes
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setSidebarOpen(true); // Auto-open on desktop
      } else {
        setSidebarOpen(false); // Auto-close on mobile
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = (menuId) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuId]: !prev[menuId]
    }));
  };

  const handleMenuClick = (page, hasChildren = false, menuId = null) => {
    if (hasChildren) {
      toggleMenu(menuId);
    } else {
      setCurrentPage(page);
     // Only collapse sidebar on mobile (screen width < 768px)
    if (window.innerWidth < 768) {
      setSidebarOpen(false);
    }
    }
  };

  return {
    currentPage,
    setCurrentPage,
    sidebarOpen,
    setSidebarOpen,
    expandedMenus,
    handleMenuClick
  };
};